import { TranslationsTypes } from './translationsTypes';
import ar from './ar.json';
import en from './en.json';

export const translations: TranslationsTypes = {
  ar,
  en,
};
